var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32Microphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,11,22)",
    d: "M4.999532 1C8.2582 1 11 3.505074 11 6.717146H9C9 4.717946 7.265138 3 4.999532 3V1ZM11 6.717146V14.283737H9V6.717146H11ZM11 14.283737C11 17.495045 8.258075 20 4.999532 20V18C7.265263 18 9 16.281937 9 14.283737H11ZM4.999532 20C1.7418 20-1 17.494927-1 14.283737H1C1 16.282053 2.734862 18 4.999532 18V20ZM-1 14.283737V6.717146H1V14.283737H-1ZM-1 6.717146C-1 3.505191 1.741675 1 4.999532 1V3C2.734987 3 1 4.717829 1 6.717146H-1Z",
    fill: "#0a7e85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,7,26)",
    d: "M19 11C19 11.552285 18.552285 12 18 12 17.447716 12 17 11.552285 17 11H19ZM1 11C1 11.552285 .552285 12 0 12-.552285 12-1 11.552285-1 11H1ZM17 11C17 6.581452 13.417993 3 8.999531 3V1C14.522389 1 19 5.476709 19 11H17ZM8.999531 3C4.581204 3 1 6.581316 1 11H-1C-1 5.476845 3.476537 1 8.999531 1V3Z",
    fill: "#0a7e85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,15.5,31)",
    d: "M1.5 6C1.5 6.552285 1.052285 7 .5 7-.052285 7-.5 6.552285-.5 6H1.5ZM-.5 2C-.5 1.447715-.052285 1 .5 1 1.052285 1 1.5 1.447715 1.5 2H-.5ZM-.5 6V2H1.5V6H-.5Z",
    fill: "#0a7e85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,7.139503,30.3001)",
    d: "M.8605 2.3001C.308215 2.3001-.1395 1.852385-.1395 1.3001-.1395 .747815 .308215 .3001 .8605 .3001V2.3001ZM16.8605 .3001C17.412785 .3001 17.8605 .747815 17.8605 1.3001 17.8605 1.852385 17.412785 2.3001 16.8605 2.3001V.3001ZM.8605 .3001H16.8605V2.3001H.8605V.3001Z",
    fill: "#0a7e85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Microphone);
export default __webpack_public_path__ + "static/media/icon32_microphone.3c5b101078645969e0bbbb636e556c2a.svg";
export { ForwardRef as ReactComponent };